import React from 'react';
import PropTypes from 'prop-types';

const contactPrivacyPolicyWrapper = ({contactsDetailsLabels}) => {
  return (
    <>
      <h2>INFORMATIVA PRIVACY – FME EDUCATION S.p.A.</h2>
      <h3>
        INFORMATIVA PRIVACY REDATTA AI SENSI DEGLI ARTT. 13 E 14 DEL REGOLAMENTO EU N.2016/679 PER IL
        TRATTAMENTO DI DATI PERSONALI
      </h3>
      <h3>1. PREMESSA</h3>
      <p>
        <strong>FME EDUCATION S.p.A.</strong>
        , c.f. e Partita IVA n. 08233380966, REA MI-2011580, con sede legale in
        20122 – Milano (MI), in Viale Majno n. 7 (in seguito anche la
        “
        <strong>Società</strong>
        ”), tel.
        {' '}
        <a href="tel:+3902300761">02/300761</a>
        , email
        {' '}
        <a
          href="mailto:privacy@fmeeducation.it"
          target="_blank"
          rel="noreferrer"
        >
          privacy@fmeeducation.it
        </a>
        ,
        proprietaria del sito web
        {' '}
        <a href="https://myedu.it">https://myedu.it</a>
        , è consapevole dell’importanza
        che riveste un trattamento responsabile dei dati personali di tutti gli internauti. Per questo la Società
        desidera informare e rassicurare circa l’utilizzo ed il trattamento dei dati personali forniti da ciascun
        internauta o comunque acquisiti
        <br />
        dal Titolare (come verrà successivamente definito) nel corso del rapporto intercorrente ovvero
        dell’interazione con le pagine del sito web
        {' '}
        <a href="https://myedu.it">https://myedu.it</a>
        , nel
        rispetto dei diritti e delle libertà fondamentali dell’individuo, nonché in maniera conforme a quanto
        prescritto dalla normativa in materia di protezione dei dati personali.
        <br />
        Si raccomanda agli interessati che si connettono al sito web di prendere attenta visione della seguente
        Informativa Privacy, redatta ai sensi degli artt. 13 e 14 del Regolamento UE n. 2016/679 in materia di
        protezione dei dati personali (in seguito anche il “
        <strong>GDPR</strong>
        ” o il
        “
        <strong>Regolamento</strong>
        ”). Si evidenzia che la presente Informativa Privacy è resa esclusivamente
        per questo sito web e non anche per altri siti web eventualmente consultabili dall’utente tramite link
        pubblicati sul sito web stesso.
        <br />
        Ai sensi della normativa vigente in materia di trattamento dei dati personali, il trattamento delle
        informazioni che La riguardano sarà improntato ai principi di correttezza, liceità, necessità,
        minimizzazione, limitazione delle finalità e della conservazione, trasparenza, esattezza, integrità e
        riservatezza, per la garanzia dei Suoi diritti.
        <br />
        Ai sensi dell’art. 13 del GDPR, Le forniamo quindi le seguenti informazioni.
      </p>
      <h3>2. TITOLARE DEL TRATTAMENTO DEI DATI</h3>
      <p>
        Il titolare del trattamento dei dati personali raccolti dalla Società, da contattare nel caso in cui
        l’utente avesse domande relative alla presente Informativa Privacy o alle modalità e funzioni del
        trattamento dei propri dati personali, è il seguente:
        <br />
        FME EDUCATION S.p.A., c.f. e Partita IVA n. 08233380966, REA MI-2011580;
        <br />
        20122 – Milano (MI), Viale Majno n. 7
        <br />
        Tel.:
        {' '}
        <a href="tel:+3902300761">02/300761</a>
        ;
        <br />
        Email:
        {' '}
        <a
          href="mailto:privacy@fmeeducation.it"
          target="_blank"
          rel="noreferrer"
        >
          privacy@fmeeducation.it
        </a>
        .
        <br />
        Ai sensi dell’art. 4 GDPR, per “Titolare del trattamento dei dati personali” (in seguito anche solo il “
        <strong>Titolare</strong>
        ”)
        si intende la persona fisica o giuridica, l’autorità pubblica, il servizio o altro organismo che,
        singolarmente o insieme ad altri, determina le finalità e i mezzi del trattamento di dati personali;
        quando le finalità e i mezzi di tale trattamento sono determinati dal diritto dell’Unione o degli Stati
        membri, il titolare del trattamento o i criteri specifici applicabili alla sua designazione possono
        essere stabiliti dal diritto dell’Unione o degli Stati membri.
      </p>
      <h3>3. DATI PERSONALI OGGETTO DEL TRATTAMENTO</h3>
      <p>
        All’atto della compilazione della richiesta di contatto verranno raccolti i dati inseriti volontariamente
        dall’utente nel form presente nella pagina, tra cui:
      </p>
      <ul>
        {
          contactsDetailsLabels.map(
            label => (
              <li
                key={label}
              >
                {label}
              </li>
            )
          )
        }
      </ul>
      <p>
        Si invita l’interessato a non inserire o inviare attraverso gli strumenti presenti sul sito “dati
        particolari” o “dati relativi alla salute” come definiti dalla normativa in vigore.
        <br />
        Tali dati, se forniti dall’interessato, saranno immediatamente cancellati.
      </p>
      <h3>4. FINALITÀ E BASE GIURIDICA DEL TRATTAMENTO DEI DATI</h3>
      <p>
        I Suoi dati personali, che ci sono stati spontaneamente forniti tramite il form di contatto del sito web,
        saranno trattati esclusivamente per finalità strettamente connesse e strumentali all’adempimento delle
        obbligazioni inerenti ai rapporti presenti e futuri con la Società, quali a solo titolo di esempio:
        <br />
        4.1. per inviare all’utente, che ne abbia fatto esplicita richiesta, i riscontri e le informazioni da
        lui sollecitati.
        <br />
        Il trattamento di dati personali per questa finalità è legittimato dalla base giuridica prevista
        dall’art. 6, par. 1, lett. b) del Regolamento, ovvero fornire all’utente il servizio richiesto;
        <br />
        4.2. per consentire, se previsto, la registrazione sul sito web della Società, se necessaria per
        l’erogazione dei prodotti da Lei richiesti e offerti dalla Società stessa. Il trattamento di dati
        personali per questa finalità è legittimato dalla base giuridica prevista dall’art. 6, par. 1, lett. b)
        del Regolamento, ovvero fornire all’utente il servizio richiesto;
        <br />
        4.3. per la tenuta dell’amministrazione e per adempiere agli obblighi previsti dalle norme di legge
        civilistiche e fiscali, dai regolamenti, dalla normativa comunitaria, per scopi statistici e per
        comunicazioni. Il trattamento di dati personali per questa finalità è legittimato dalla base giuridica
        prevista dall’art. 6, par. 1, lett. c) del Regolamento, ovvero adempiere un obbligo legale al quale è
        soggetto il titolare del trattamento;
        <br />
        4.4. per l’invio di materiale pubblicitario, di comunicazioni commerciali inerenti i nostri prodotti, di
        vendita diretta, informazioni sui prodotti della nostra Società o di società ad essa collegate che
        svolgono la stessa attività o attività affini, per gli inviti ad eventi, presentazioni o iniziative di
        P.R., di studi, di convegni, o di presentazione di prodotti di società collegate (a mezzo fax, telefono,
        posta elettronica, sms e WhatsApp), anche per il tramite di commerciali nonché di nostri agenti. Il
        trattamento di dati personali per questa finalità è legittimato dalla base giuridica prevista dall’art.
        6, par. 1, lett. a) del Regolamento, ovvero l’interessato ha prestato il suo consenso.
      </p>
      <h3>5. NATURA DELLA RACCOLTA DEI DATI E CONSEGUENZE DI UN EVENTUALE MANCATO CONFERIMENTO</h3>
      <p>
        Il conferimento dei Suoi dati personali è obbligatorio, al fine di ottenere riscontro alla propria
        richiesta di contatto e di osservare gli adempimenti di legge, con la precisazione che il mancato,
        parziale o inesatto conferimento dei dati personali, in quanto necessari per l’esecuzione della
        prestazione richiesta, non rende possibile tale esecuzione, mentre il mancato, parziale o inesatto
        conferimento dei dati personali facoltativi non necessari non comporta alcuna conseguenza, così come il
        mancato consenso per le finalità di cui al precedente
        <br />
        punto 4.4.
        <br />
        Oltre ai dati personali conferiti direttamente dagli utenti (quali nome, cognome, indirizzo postale, di
        posta elettronica, dati di contatto, ecc.) in fase di connessione al sito web, ove previsto, i sistemi
        informatici e le procedure software preposte al funzionamento del sito stesso acquisiscono
        indirettamente alcuni dati personali, la cui trasmissione è implicita nell’uso dei protocolli di
        comunicazione di internet. Tali dati vengono trattati al solo fine di effettuare indagini statistiche in
        forma anonima.
      </p>
      <h3>6. MODALITÀ DI TRATTAMENTO E PERIODO DI CONSERVAZIONE</h3>
      <p>
        I dati personali degli internauti saranno trattati in forma elettronica e/o cartacea, nel rispetto dei
        principi stabiliti dalla normativa di protezione dei dati personali. Il trattamento avverrà previa
        adozione di ogni misura di sicurezza, tecnica ed organizzativa, adeguata ai rischi per i diritti e le
        libertà fondamentali dell’Interessato. I dati sono trattati presso le sedi operative del Titolare ed in
        ogni altro luogo in cui le parti coinvolte nel trattamento siano localizzate. I dati personali
        dell’Interessato potrebbero essere trasferiti in un paese diverso da quello in cui l’Interessato si trova.
        <br />
        Le operazioni di trattamento saranno svolte da soggetti autorizzati dalla Società e dal Titolare ad
        accedere alle informazioni, i quali saranno adeguatamente istruiti in merito alla protezione dei dati
        personali e designati quali incaricati del trattamento.
        <br />
        I dati personali raccolti saranno conservati per tutto il periodo di erogazione del servizio e per un
        periodo di tempo non superiore a quello necessario al conseguimento delle finalità per le quali sono
        raccolti e saranno cancellati nel termine massimo di n. 15 giorni dall’esaurimento di tali attività. I
        dati raccolti non saranno in ogni caso conservati oltre il tempo massimo previsto dalle disposizioni di
        legge applicabili (ad esempio prescrizione decennale per i dati di natura civilistica).
      </p>
      <h3>7. COMUNICAZIONE E DIFFUSIONE DEI DATI</h3>
      <p>
        I Suoi dati personali, ivi compresi eventualmente quelli del minore su cui Lei esercita la potestà
        genitoriale, ai fini dell’esecuzione dei prodotti forniti e per le finalità sopra indicate, nonché per
        esigenze tecniche, operative, pratiche, di mercato, di pubblicizzazione e promozione, collegate alle
        finalità indicate al punto 4) “Finalità e base giuridica del trattamento dei dati”, strettamente connesse
        all’attività della Società, potranno essere comunicati a terze parti e in particolare:
        <br />
        7.1. a tutte le persone fisiche e giuridiche, o società partner o collegate alla Società, operanti nel
        medesimo settore merceologico, nei casi in cui la comunicazione risulti necessaria per le finalità sopra
        illustrate;
        <br />
        7.2. per quanto concerne il servizio di invio di mailing list, a società esterne, qualora la Società si
        avvalga di piattaforme esterne per tale attività;
        <br />
        7.3. a tutte le persone fisiche (ivi compresi i commerciali e gli agenti) e giuridiche, per le finalità
        di cui al punto 4.4, laddove non sia stato esplicitamente negato il consenso;
        <br />
        7.4. ai collaboratori e dipendenti appositamente designati quali incaricati del trattamento e
        nell’ambito delle relative mansioni, compreso il servizio di help desk, che opereranno sotto la diretta
        autorizzazione del Titolare e che riceveranno a riguardo adeguate istruzioni operative e di
        sicurezza;
        <br />
        7.5. alle pubbliche autorità e amministrazioni dello Stato per finalità connesse all’adempimento degli
        obblighi di legge, per motivi di indagine, di accertamento e di repressione di illeciti amministrativi,
        fiscali, contabili, tributari e penali;
        <br />
        7.6. a società che offrono servizi informatici e/o di sviluppo e manutenzione Software e del sito
        internet e di aggiornamento e revisione degli strumenti informatici.
        <br />
        Il loro elenco è costantemente aggiornato e può essere reperito agevolmente e gratuitamente inviando una
        comunicazione scritta al Titolare del trattamento all’indirizzo sopra indicato o una email a:
        {' '}
        <a
          href="mailto:privacy@fmeeducation.it"
          target="_blank"
          rel="noreferrer"
        >
          privacy@fmeeducation.it
        </a>
      </p>
      <h3>8. TRASFERIMENTO DI DATI AL DI FUORI DELL’UNIONE EUROPEA</h3>
      <p>
        La Società non trasferisce i dati personali degli interessati, raccolti attraverso il sito
        <a
          href="https://myedu.it"
        >
          https://myedu.it
        </a>
        {' '}
        e gli strumenti ivi previsti, in paesi situati fuori
        dall’Unione Europea.
      </p>
      <h3>9. COLLEGAMENTO A SITI O SERVIZI DI SOGGETTI TERZI</h3>
      <p>
        La presente informativa è resa solo per i trattamenti di dati personali effettuati attraverso il presente
        sito web o gli strumenti previsti dallo stesso, e non anche per altri siti web eventualmente consultati
        dall’utente tramite link, i cui gestori operano in qualità di titolari autonomi del trattamento. Si
        invitano pertanto gli utenti a leggere con attenzione, prima di accedere a servizi di soggetti terzi, le
        loro informative privacy.
      </p>
      <h3>10. DIRITTI DELL’INTERESSATO</h3>
      <p>
        Gli articoli 12, 15, 16, 17, 18, 20 e 34 del Regolamento conferiscono agli Interessati la possibilità di
        esercitare specifici diritti.
        <br />
        L’Interessato potrà in ogni momento esercitare i Suoi diritti nei confronti del Titolare o del
        responsabile del trattamento.
        <br />
        In particolare, l’Interessato può ottenere:
        <br />
        a) conferma dell’esistenza o meno di dati personali che lo riguardano, anche se non ancora registrati, e
        la loro comunicazione in forma intelligibile;
        <br />
        b) informazioni sulle finalità e modalità del trattamento;
        <br />
        c) informazioni sulle categorie di dati personali in questione;
        <br />
        d) gli estremi identificativi del titolare e, se designato, del responsabile del trattamento
        <br />
        e) i destinatari o le categorie di destinatari a cui i dati personali sono stati o saranno comunicati,
        in particolare se destinatari di Paesi terzi o organizzazioni internazionali;
        <br />
        f) quando è possibile, il periodo di conservazione dei dati personali previsto, oppure, se non è
        possibile, i criteri utilizzati per determinare tale periodo;
        <br />
        g) l’aggiornamento, la rettificazione ovvero, quando vi ha interesse, l’integrazione e la limitazione
        dei dati personali;
        <br />
        h) la cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in violazione di
        legge o per adempiere ad un obbligo legale previsto dal diritto dell’Unione Europea o dal diritto
        italiano, compresi quelli di cui non è necessaria la conservazione in relazione agli scopi per i quali i
        dati sono stati raccolti o successivamente trattati (cd. diritto all’oblio);
        <br />
        i) la revoca del consenso prestato, quando questo si basi sull’ipotesi prevista dall’art. 6, par. 1,
        lett. a. (quando “l’interessato ha espresso il consenso al trattamento dei propri dati personali per una
        o più specifiche finalità”), oppure dall’art. 9, par. 2, lett. a. (quando “l’interessato ha prestato il
        proprio consenso esplicito al trattamento di tali dati personali per una o più finalità specifiche”) del
        GDPR, in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso prestato
        prima della revoca;
        <br />
        j) la limitazione del trattamento, nelle ipotesi previste dal Regolamento; k) la comunicazione
        dell’eventuale violazione dei dati personali, quando questa sia suscettibile di presentare un elevato
        rischio per i diritti e le libertà delle persone fisiche, salvo che il Titolare abbia messo in atto
        misure tecniche e organizzative per rendere i dati incomprensibili a chiunque non fosse autorizzato
        ad
        <br />
        accedervi, oppure abbia successivamente adottato misure atte a scongiurare il sopraggiungere di tale
        elevato rischio, ovvero detta comunicazione richiederebbe sforzi sproporzionati;
        <br />
        l) la ricezione, in un formato strutturato, di uso comune e leggibile da dispositivo automatico, dei
        dati personali forniti al Titolare, nonché la trasmissione degli stessi a un altro titolare del
        trattamento, e ciò in qualsiasi momento, anche alla cessazione dei rapporti eventualmente intrattenuti
        col Titolare, e, se tecnicamente fattibile, di ottenerne la trasmissione diretta, a condizione che sia
        stato richiesto il consenso.
        <br />
        L’Interessato ha altresì diritto di opporsi in qualsiasi momento, in tutto o in parte, ferme restando le
        possibili conseguenze di cui all’art. 2, c. 1, del Regolamento:
        <br />
        – per motivi legittimi al trattamento dei dati personali che lo riguardano, ancorché pertinenti allo
        scopo della raccolta;
        <br />
        – al trattamento dei dati personali che lo riguardano svolto ai sensi dell’art. 6, par. 1, lett. e. (“il
        trattamento è necessario per l’esecuzione di un compito di interesse pubblico o connesso all’esercizio
        di pubblici poteri di cui è investito il titolare del trattamento”) o lett. f. (“il trattamento è
        necessario per il perseguimento del legittimo interesse del titolare del trattamento o di terzi”) del
        GDPR, compresa la profilazione sulla base di tali disposizioni;
        <br />
        – al trattamento dei dati personali che lo riguardano a fini di invio di materiale pubblicitario o di
        vendita diretta o per il compimento di ricerche di mercato o di comunicazione commerciale (marketing
        diretto), compresa la profilazione nella misura in cui sia ad esso connessa.
        <br />
        L’Interessato, nel caso in cui ritenga che il trattamento che lo riguarda violi la normativa in vigore,
        ha il diritto di proporre reclamo a un’autorità di controllo, segnatamente a quella dello Stato membro
        in cui risiede abitualmente, lavora oppure del luogo ove si è verificata la presunta violazione.
        L’Autorità di controllo italiana può essere raggiunta ai recapiti presenti sul proprio sito web.
        <br />
        I diritti di cui all’art. 8 GDPR sono esercitati con richiesta rivolta senza formalità al Titolare o al
        responsabile del trattamento, anche per il tramite di un incaricato, alla quale è fornito idoneo
        riscontro senza ingiustificato ritardo e comunque entro un mese, prorogabile di un mese, dal ricevimento
        della richiesta.
        <br />
        La richiesta rivolta al Titolare può essere trasmessa anche mediante invio di raccomandata alla sede
        della Società o all’indirizzo di posta elettronica:
        {' '}
        <a
          href="mailto:privacy@fmeeducation.it"
          target="_blank"
          rel="noreferrer"
        >
          privacy@fmeeducation.it
        </a>
        <br />
        Rammentiamo, inoltre, che, qualora il trattamento dei dati dell’utente si basi sul consenso, l’utente
        avrà sempre il diritto di revocarlo: ricordiamo, peraltro, che la revoca non invalida il trattamento
        fino ad allora svolto dalla Società e/o dal Titolare, e che essa potrebbe impedire alla Società di
        perseguire le finalità richieste dall’utente.
      </p>
      <h3>11. MODIFICHE ALLE PRESENTI POLITICHE SULLA PRIVACY</h3>
      <p>
        Il Titolare si riserva il diritto di apportare modifiche alla presente informativa adeguandola alle
        eventuali normative, organizzative e tecnologiche. In caso di modifica, la nuova versione della stessa
        sarà pubblicata sui siti internet facenti capo alla Società e, dunque, l’utente viene invitato a
        monitorare periodicamente le informazioni ivi contenute.
      </p>
    </>
  );
};

contactPrivacyPolicyWrapper.propTypes = {
  contactsDetailsLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default contactPrivacyPolicyWrapper;
